import { isEmpty } from 'lodash';
import queryString from 'qs';

const getUserListRequest = (filter) => {
  const queries = { limit: 10, page: filter?.page };

  if (filter?.search) queries['search'] = filter?.search;

  if (filter?.account) queries['accountLivestreams.id'] = `[${filter.account?.map(({ value }) => value)}]`;
  if (filter?.role) queries['role.id'] = `[${filter.role?.map(({ value }) => value)}]`;
  if (filter?.brand) queries['brands.id'] = `[${filter.brand?.map(({ value }) => value)}]`;
  if (filter?.platform) queries['ecommerces.id'] = `[${filter.platform?.map(({ value }) => value)}]`;
  if (filter?.sort) queries['sort'] = `${filter?.sort?.field}.${filter?.sort?.order}`;
  if (!isEmpty(filter?.status)) queries['status'] = filter?.status?.value;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getUserListRequest;
